import { contexts } from '~/const/global'

export default superclass => class extends superclass {
  // Contexts class.
  static contexts = contexts
}
